import { Components, Theme } from '@mui/material';

export const components: Components<Omit<Theme, 'components'>> = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 5,
        textTransform: 'none',
        fontWeight: 400,
      },
      containedPrimary: {
        backgroundColor: '#3FAE2A',
        '&:hover': {
          backgroundColor: '#3FAE2A',
        },
      },
      outlinedPrimary: {
        borderColor: '#3FAE2A',
        color: '#3FAE2A',
        '&:hover': {
          borderColor: '#3FAE2A',
          backgroundColor: 'transparent',
        },
      },
      sizeLarge: {
        height: 44,
      },
      sizeMedium: {
        height: 40,
      },
      sizeSmall: {
        height: 30,
      },
    },
  },
  MuiTextField: {
    defaultProps: {
      variant: 'outlined',
      size: 'medium',
    },
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root': {
          borderRadius: 5,
          backgroundColor: '#EFF3F6',
          '&:hover': {
            backgroundColor: '#F7F9FC',
          },
          '&.Mui-focused': {
            backgroundColor: '#F7F9FC',
          },
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#B5B5B5',
        },
        '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#3FAE2A',
        },
        '& .MuiInputLabel-root': {
          color: '#576473',
        },
        '& .MuiInputBase-input': {
          color: '#141F2B',
          fontSize: '14px',
        },
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 6,
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        border: '1px solid #DBE2E9',
      },
    },
  },
  MuiCardHeader: {
    styleOverrides: {
      root: {
        padding: '16px 20px',
      },
      title: {
        fontSize: '16px',
        fontWeight: 500,
      },
    },
  },
  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: '20px',
        '&:last-child': {
          paddingBottom: '20px',
        },
      },
    },
  },
  MuiCardActions: {
    styleOverrides: {
      root: {
        padding: '16px 20px',
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        padding: '12px 16px',
        fontSize: '14px',
        color: '#576473',
      },
      head: {
        fontWeight: 600,
        backgroundColor: '#F7F9FC',
        color: '#141F2B',
        borderTop: '1px solid #DBE2E9',
      },
      body: {
        borderTop: '1px solid #DBE2E9',
      },
    },
  },
  MuiTableRow: {
    styleOverrides: {
      root: {
        '&:hover': {
          backgroundColor: 'rgba(247, 249, 252, 0.5)',
        },
        '&:last-child td': {
          borderBottom: 0,
        },
      },
    },
  },
  MuiTableContainer: {
    styleOverrides: {
      root: {
        overflowX: 'auto',
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: 20,
        fontSize: '14px',
        height: 'auto',
        padding: '3px 5px',
      },
      colorSuccess: {
        backgroundColor: '#B8FBF0',
        color: '#3FAE2A',
      },
      colorError: {
        backgroundColor: '#FFECFC',
        color: '#9D0F41',
      },
    },
  },
  MuiAlert: {
    styleOverrides: {
      root: {
        borderRadius: 6,
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      rounded: {
        borderRadius: 6,
      },
      elevation1: {
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        backgroundColor: '#ffffff',
        color: '#141F2B',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
      },
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: {
        backgroundColor: '#ffffff',
        borderRight: '1px solid #DBE2E9',
      },
    },
  },
  MuiSelect: {
    styleOverrides: {
      outlined: {
        borderRadius: 5,
        fontSize: '14px',
        backgroundColor: '#EFF3F6',
      },
      select: {
        fontSize: '14px',
      },
    },
  },
  MuiFormControl: {
    styleOverrides: {
      root: {
        marginBottom: '16px',
      },
    },
  },
  MuiFormLabel: {
    styleOverrides: {
      root: {
        fontSize: '14px',
        color: '#576473',
        marginBottom: '8px',
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        fontSize: '14px',
        color: '#576473',
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        fontSize: '14px',
        fontWeight: 500,
        minWidth: 'auto',
        padding: '12px 16px',
      },
    },
  },
  MuiTabs: {
    styleOverrides: {
      indicator: {
        backgroundColor: '#3FAE2A',
      },
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        color: '#576473',
        '&:hover': {
          backgroundColor: 'rgba(247, 249, 252, 0.8)',
        },
      },
    },
  },
  MuiDivider: {
    styleOverrides: {
      root: {
        backgroundColor: '#B5B5B5',
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: 6,
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
      },
    },
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        fontSize: '18px',
        fontWeight: 600,
        padding: '16px 20px',
      },
    },
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        padding: '20px',
      },
    },
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        padding: '16px 20px',
      },
    },
  },
};

export default components;